<template>
    <div>
        <div class="topSearch">
            <div class="logo">
                <img width="30%" src="../assets/images/logo.png" alt="">
                <div>
                    连云港格润环保科技有限公司
                </div>
            </div>
            <!-- <div class="searchArea">
                <el-input size="small" v-model="input" placeholder="请输入内容"></el-input><el-button size="small" type="primary">搜索</el-button>
            </div> -->
        </div>
        <div class="menuBar">
            <div class="menuBox">
                <div v-for="(item, index) in navBar" :key="index" :class="{'active':item.active}" class="menuItem"  @click="menuClick(item)">{{ item.name }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'top',
    data () {
        return {
            input: '',
            navBar: [
                {
                    name:'网站主页',
                    url:'/index',
                    active:true,
                },
                {
                    name:'企业概况',
                    url:'/profile',
                    active:false,
                },
                {
                    name:'新闻中心',
                    url:'/news',
                    active:false,
                },
                {
                    name:'公司业绩',
                    url:'/achieve',
                    active:false,
                },
                {
                    name:'公示通知',
                    url:'/publicity',
                    active:false,
                },
                {
                    name:'联系我们',
                    url:'/contact',
                    active:false,
                }
            ]
        }
    },
    methods: {
        menuClick (item) {
            this.$router.push(item.url)
        },
    },
    mounted() {
        this.navBar.forEach(val => {
            val.active = false
            if (val.url === this.$route.path) {
                val.active = true
            }
        });
    },
    watch:{
        $route(to,from){
            if (to.path) {
                this.navBar.forEach(val => {
                    val.active = false
                    if (val.url === to.path) {
                        val.active = true
                    }
                });
            }
        },
    },
}
</script>

<style scoped>
    .logo {
        padding: 10px 0;
        width: 35%;
        cursor: pointer;
        display: flex;
        align-items: center;
        /* justify-content: space-between; */
        font-weight: bold;
        font-size: 20px;
    }
    .logo div {
        padding-left: 10px;
        color: #004A8F;
    }
    .topSearch{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        margin: 0 auto;
    }
    .searchArea {
        display: flex;
    }
    .menuBar {
        width: 100%;
        background: #49a8f8;
    }
    .menuBox {
        justify-content: space-between;
        display: flex;
        height: 40px;
        width: 1200px;
        margin: 0 auto;
    }
    .menuItem {
        color: white;
        cursor: pointer;
        height: 100%;
        line-height: 40px;
        width: 200px;
        text-align: center;
    }
    .menuItem:hover,.menuItem.active {
        background: #1f8bea;
    }
</style>